import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { getLocale } from '@vendasta/galaxy/i18n';
import { localizedWeekday } from '@vendasta/galaxy/utility/date-utils';
import { DayOfWeek } from '@vendasta/listing-products';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EditRegularHoursDialogComponent } from './edit-regular-hours-dialog/edit-regular-hours-dialog.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'forms-business-hours',
  templateUrl: './business-hours.component.html',
  styleUrls: ['./business-hours.component.scss'],
  standalone: false,
})
export class BusinessHoursComponent {
  @Input() control: UntypedFormControl;
  @Input() markedAsRequired = false;
  @Input() loading$: Observable<boolean>;
  @Output() changes = new EventEmitter();

  private editDialogRef: MatDialogRef<EditRegularHoursDialogComponent>;

  constructor(private dialog: MatDialog) {}

  openEditDialog(): void {
    if (this.control.disabled) {
      return;
    }
    this.control.markAsTouched();
    this.dialog.closeAll();
    this.editDialogRef = this.dialog.open(EditRegularHoursDialogComponent, {
      width: '660px',
      maxWidth: '100vw',
    });
    this.editDialogRef.componentInstance.control = this.control;
    this.editDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.control.setValue(result);
        this.control.markAsDirty();
        this.changes.emit();
      }
      this.editDialogRef = null;
    });
  }

  dayOfWeek(dayOfWeek: number): DayOfWeek {
    const locale = getLocale();
    return {
      0: DayOfWeek.SUNDAY,
      1: DayOfWeek.MONDAY,
      2: DayOfWeek.TUESDAY,
      3: DayOfWeek.WEDNESDAY,
      4: DayOfWeek.THURSDAY,
      5: DayOfWeek.FRIDAY,
      6: DayOfWeek.SATURDAY,
    }[localizedWeekday(dayOfWeek, { code: locale })];
  }
}
